/**
 * Modal state for the fix-errors page.
 *
 * At most one modal is open at a time across the validation + API completion
 * paths, so the page's modal surface is a discriminated union rather than five
 * independent booleans. Maps to the original `showModal*` flags as:
 *
 *  - 'partial-success'        ← order bulk-update succeeded with rejected rows
 *                               (required errors remain; Fix vs Continue)
 *  - 'all-mandatory'          ← every row has at least one required error
 *                               (Continue disabled; Fix only)
 *  - 'property-optional'      ← property optional-field warnings before import
 *  - 'order-optional'         ← order optional-field warnings (all rows fixable)
 *  - 'order-partial-optional' ← order optional-field warnings (partial rows)
 */

export type FixErrorModal =
  | { kind: 'none' }
  | { kind: 'partial-success' }
  | { kind: 'all-mandatory' }
  | { kind: 'property-optional' }
  | { kind: 'order-optional' }
  | { kind: 'order-partial-optional' };

export const NO_MODAL: FixErrorModal = { kind: 'none' };
